export default __webpack_public_path__ + "static/media/RestaurantBag.aed0b00b.jpg";